import styled, { css } from 'styled-components';
import { List } from '@mui/material';

import { ReactComponent as ArchiveIcon } from '../../../assets/icons/archive-icon.svg';
import { ReactComponent as UnarchiveIcon } from '../../../assets/icons/unarchive-icon.svg';
import { ReactComponent as HideIcon } from '../../../assets/icons/hide-icon.svg';
import { ReactComponent as ShowIcon } from '../../../assets/icons/show-icon.svg';
import colors from '../../../styles/colors';

const iconStyle = css`
  width: 30px;
  height: 30px;
`;

const StyledArchiveIcon = styled(ArchiveIcon)`
  ${iconStyle}
`;

const StyledUnarchiveIcon = styled(UnarchiveIcon)`
  ${iconStyle}
`;

const StyledHideIcon = styled(HideIcon)`
  ${iconStyle}
`;

const StyledShowIcon = styled(ShowIcon)`
  ${iconStyle}
`;

const StyledList = styled(List)`
  width: 100%;
  background-color: ${colors.base.alpha};
  border-radius: 5px;
`;

export {
  StyledArchiveIcon,
  StyledUnarchiveIcon,
  StyledHideIcon,
  StyledShowIcon,
  StyledList,
};
